<template>
  <ul class="Breadcrumbs-Main">
    <li class="Breadcrumbs-Main__item" v-for="(item, index) in props.breadcrumbs" :key="index">
      <router-link class="Breadcrumbs-Main__lnk" v-if="item.route" :to="{ name: item.route }">{{ item.text }}</router-link>
      <span class="Breadcrumbs-Main__txt" v-else v-html="item.text"></span>
      <ArrowTiny v-if="isNotLast(index)" class="Breadcrumbs-Main__arrow" />
    </li>
  </ul>
</template>

<script setup>
  import { defineProps } from 'vue';
  import { Props } from './scripts/props.js';
  //--------------------------
  import ArrowTiny from '@svg/ArrowTiny.vue';
  //--------------------------
  const props = defineProps(Props());
  //--------------------------
  const isNotLast = (index) => index < props.breadcrumbs.length - 1;
</script>

<style lang="scss">
  @import "./styles/_style";
</style>